export default class UserbackSingleton {
  private static instance: UserbackSingleton;
  private initialized: boolean;

  private constructor() {
    this.initialized = false;
    this.init();
  }

  public init(): void {
    if (!this.initialized) {
      window.Userback = window.Userback || {};
      window.Userback.access_token = "A-kSdhVzQdjntAsR2Q1Pk6c9VBs";

      // Load Userback script
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://static.userback.io/widget/v1.js";
      (document.head || document.body).appendChild(script);

      this.initialized = true;
    }
  }

  public static getInstance(): UserbackSingleton {
    if (!UserbackSingleton.instance) {
      UserbackSingleton.instance = new UserbackSingleton();
    }
    return UserbackSingleton.instance;
  }

  public identify(userData: { id: string; name: string; email: string }): void {
    if (!this.initialized) {
      this.init();
    }

    window.Userback.user_data = {
      id: userData.id,
      info: {
        name: userData.name,
        email: userData.email
      }
    };
  }

  public reset(): void {
    if (window.Userback) {
      window.Userback.user_data = undefined;
    }
  }
}

declare global {
  interface Window {
    Userback: {
      access_token?: string;
      user_data?: {
        id: string;
        info: {
          name: string;
          email: string;
        };
      };
    };
  }
}
